class ProjectsLoop {
    constructor() {
        this.cards = Array.from(document.querySelectorAll('[data-project-card]'));
        if (this.cards.length === 0) {
            return;
        }

        this.prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

        this.instances = this.cards
            .map((card, idx) => this.initCard(card, idx))
            .filter(Boolean);
    }

    initCard(card, idx) {
        const slides = Array.from(card.querySelectorAll('.project-slide'));
        if (slides.length <= 1 || this.prefersReducedMotion) {
            return null;
        }

        let current = 0;
        const total = slides.length;

        // small stagger so not all projects switch at the same time
        const baseDelay = 1400;
        const intervalMs = baseDelay + (idx % 4) * 150;

        const tick = () => {
            slides[current].classList.remove('active');
            current = (current + 1) % total;
            slides[current].classList.add('active');
        };

        const timer = window.setInterval(tick, intervalMs);

        return { card, timer };
    }

    destroy() {
        this.instances.forEach(({ timer }) => window.clearInterval(timer));
        this.instances = [];
    }
}

let projectsLoopInstance = null;

export function initProjectsLoop() {
    try {
        projectsLoopInstance?.destroy?.();
    } catch (_) { }
    projectsLoopInstance = new ProjectsLoop();
}

// Initialized by page-init.js (also re-inits after Swup navigation)
